import { render, staticRenderFns } from "./AddEvaluationProject.vue?vue&type=template&id=c075f8de"
import script from "./AddEvaluationProject.vue?vue&type=script&lang=js"
export * from "./AddEvaluationProject.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports